import { LoginForm } from '@components/Component/Container/Form/LoginForm/LoginForm.js';
import DIContainer from '@components/DependencyInjectionContainer.js';
import { ENV } from '@components/Environment.js';
import { oAuthPopup, oAuthNative } from '@components/Utility/index.js';
import { eventContextGet } from '@components/EventConfigManager/EventConfigManagerUtil.js';
import { createElement } from '@components/Utility/index.js';
export class LoginFormOverlay extends LoginForm {
    constructor() {
        super(...arguments);
        this.componentName = 'LoginFormOverlay';
    }
    draw() {
        super.draw();
        this.rootElement.classList.add('s360LoginForm');
        if (ENV('appName') === 'q360MobileApp' && ENV('isNative')) {
            this.renderChangeDomainButton();
        }
    }
    initializeComponents() {
        super.initializeComponents();
        //this.componentRemove('forgotpassword')
        // we'll just override the existing forgot password component so we don't have to redo the template
        const forgotpassword = this.componentGet('forgotpassword');
        if (forgotpassword) {
            forgotpassword.captionKey = 'system_login_logout';
            forgotpassword.before('click', () => {
                window.location.reload();
                return false;
            });
        }
    }
    renderChangeDomainButton() {
        const loginContainer = this.rootElement.querySelector('.login-form-container form');
        if (!loginContainer)
            return;
        const wrapper = createElement('div');
        wrapper.className = 'form-group change-domain-container';
        const button = DIContainer.new('Button', 'changedomain', createElement('div'));
        button.propertiesLoad({
            caption: 'Change Environment',
            buttonSize: 'large',
            styleModifier: 'tertiary',
            buttonIcon: 'swap_horiz'
        });
        button.on('click', () => {
            DIContainer.getInstance('Application').reset();
        });
        this.componentAdd(button, false);
        button.draw();
        wrapper.appendChild(button.rootElement);
        loginContainer.appendChild(wrapper);
    }
    oAuthButtonClick(webmailconfigno) {
        const context = eventContextGet({ initiator: this });
        const oauth$ = ENV('isNative')
            ? oAuthNative({ webmailconfigno }, context)
            : oAuthPopup({ webmailconfigno }, context);
        oauth$.subscribe(() => {
            this.finalizeLogin('oauth');
        });
    }
    login() {
        const enteredUserId = this.record?.get('userid');
        const sessionUserId = ENV('userId');
        const sessionNetworkLogin = ENV('networkLogin');
        if (!enteredUserId) {
            return;
        }
        if (sessionUserId && enteredUserId.toUpperCase() !== sessionUserId.toUpperCase() && enteredUserId.toUpperCase() !== sessionNetworkLogin.toUpperCase()) {
            this.confirm({ captionKey: 'system_login_restore_wrong_userid' })
                .subscribe(() => {
                window.location.reload();
            });
        }
        else {
            super.login();
        }
    }
    mainHeadingCaptionGet(subHeading = false) {
        if (!ENV('userId')) {
            // if no session userid yet, its just the regular login (login overlay used in the mobile app)
            return super.mainHeadingCaptionGet(subHeading);
        }
        let caption;
        if (subHeading) {
            caption = this.CaptionManager.getCaption('system_login_subheading_expired');
        }
        else {
            caption = this.CaptionManager.getCaption('system_login_heading_expired');
        }
        return caption;
    }
    finalizeLogin(source = 'login') {
        const bm = DIContainer.getInstance('BroadcastManager');
        bm.send('session-restored', { payload: { source: source } });
    }
}
LoginFormOverlay.VERSION = '$Revision: 123195 $';
